import FormRender from "@/components/Form/Renderer/RenderForm";
import { updateTempPassword } from "@/services/common/security.services";
import { UpdatePasswordConfig } from "@/utils/constant/formConfig.constant";
import { toastMessage } from "@/utils/helper/myToast";
import React from "react";

interface UpdateTempPasswordProps {
  onClose: (props?: any) => void;
}

const UpdateTempPassword: React.FC<UpdateTempPasswordProps> = ({ onClose }) => {
  const handleFormSubmit = async (data: any) => {
    const { confirmPassword, ...payload } = data;
    const res: any = await updateTempPassword(payload);
    if (res?.status === 200) {
      const { message, isError } = res.data;
      toastMessage(message, isError);
      setTimeout(() => {
        window.location.href = "/login/organization";
      }, 50);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };

  return (
    <FormRender
      useFormConfig={{ mode: "onSubmit", reValidateMode: "onChange", criteriaMode: "all" }}
      handleFormSubmit={handleFormSubmit}
      handleCancel={onClose}
      formConfig={UpdatePasswordConfig}
      className="p-4"
      formClassName=""
    />
  );
};

export default UpdateTempPassword;
